import React, { Component, type ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error('UI ErrorBoundary caught an error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FDFDFD] flex items-center justify-center p-6">
          <div className="max-w-md w-full bg-white border border-stone-200 rounded-2xl p-6 text-center">
            <h2 className="text-lg font-bold text-stone-900">Terjadi kesalahan</h2>
            <p className="text-sm text-stone-600 mt-2">Silakan refresh halaman. Jika masih terjadi, hubungi admin.</p>
            <button
              className="mt-4 px-4 py-2 bg-stone-900 hover:bg-black text-white rounded-xl text-sm font-medium transition-colors"
              onClick={() => window.location.reload()}
              type="button"
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
